/**
 * ENUM
 * Normaliza codigos de tipos de questoes para questionarios do EAD.
 *
 * @author hjCostaBR
 */
export const QuestionTypeEnum = {
    ONE_ANSWER : 1,
    TRUE_OR_FALSE : 2,
    OPEN_ANSWER : 3
}


// WEBPACK FOOTER //
// ./src/enums/QuestionTypeEnum.js